import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/messages.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";

function Messages() {
  const [usersData, setUsersData] = useState(null);
  const [messagesdata, setMessagesdata] = useState([]);
  const config = configModule.config();

  const getMessageData = async () => {

    try {
      const response = await axios.get(
        `${config.apiBaseUrl}/get-messages/${usersData?.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data?.data;
      setMessagesdata(data);

    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      toast.error(message);
    }
  };

  useEffect(() => {
    if (usersData?.id) {
      getMessageData();
    }
  }, [usersData]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decoded = jwtDecode(token);
      setUsersData(decoded);
    }
  }, []);

  const formatPaymentDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    let hours = d.getUTCHours();
    const minutes = String(d.getUTCMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours || 12;

    hours = String(hours).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  };

  return (
    <div className='dashboardmain-st'>
      <Header pageName="Messages" />
      <div className="body-dashboard">
        <div className="page-header">
          <div className="page-eyebrow">Inbox</div>
          <div className="page-title">Messages</div>
        </div>

        <div className="lxp-card">
          {messagesdata?.length > 0 ? messagesdata.map((item, index) => (
            <div className="lxp-txn-row" key={index} style={{ alignItems: "flex-start" }}>
              <div className="lxp-txn-icon msg">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <div>
                <div className="lxp-txn-title lxp-txn-title-st">{item?.subject || ''} <span
                  style={{ display: "inline-block", width: "7px", height: "7px", background: "var(--red)", borderRadius: "50%", marginLeft: "4px" }}></span></div>
                <div className="lxp-txn-sub" style={{ marginTop: "4px", color: "var(--text-muted)" }}>{item?.message || ''}</div>
                <div className="lxp-txn-sub" style={{ marginTop: "4px" }}>{item?.created_at ? formatPaymentDate(item?.created_at) : ''}</div>
              </div>
            </div>
          )) : (
            <div className="text-center p-4" style={{ background: "#f7f2e8" }}>
              No Messages found...!
            </div>
          )}
        </div>
      </div>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#0a1628",
            color: "#fff",
            borderRadius: "10px",
            padding: "14px 18px",
          },
          success: {
            iconTheme: {
              primary: "#22c55e",
              secondary: "#fff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
    </div>
  )
}

export default Messages;
